
import { Mapper } from "../../../../base/utils/mapper";
import { AnalysisMarchPhysiotherapyResponseModel } from "../../../../domain/models/consult/analysis-march-physiotherapy-response.model";
import { AnalysisMarchPhysiotherapyResponseEntity } from "../entities/analysis-march-physiotherapy-response.entity";

export class AnalysisMarchPhysiotherapyImplementationRepositoryMapper extends Mapper<AnalysisMarchPhysiotherapyResponseEntity, AnalysisMarchPhysiotherapyResponseModel>{
            mapFrom(param: AnalysisMarchPhysiotherapyResponseEntity): AnalysisMarchPhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param: AnalysisMarchPhysiotherapyResponseModel): AnalysisMarchPhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }